<template>
    <div class="chatList" v-loading='loading' v-if="to_user">
        <div v-if="to_user.show_user_type=='user'">
            <div class="topuser">
                <div class="pic">
                    <img :src="userdetail.avatar" alt="">
                </div>
                <div class="username">
                    {{userdetail.nickname}}
                </div>
                <div class="sex">
                    <img v-if="userdetail.wechatUsers&&userdetail.wechatUsers.sex==1" src="../../../assets/imgs/nan.png"
                        alt="">
                    <img v-else src="../../../assets/imgs/nv.png" alt="">
                </div>
            </div>
            <div class="info_item">
                <span class="info_tit">电话：</span><span class="info_text">{{userdetail.phone}}</span>
            </div>
            <div class="info_item">
                <span class="info_tit">微信：</span><span class="info_text">{{userdetail.wechat}}</span>
            </div>
            <div class="info_item">
                <span class="info_tit">注册时间：</span><span class="info_text">{{userdetail.create_time}}</span>
            </div>
            <div class="info_item">
                <span class="info_tit">用户类型：</span><span
                    class="info_text">{{({1:'普通用户',2:'专家'})[userdetail.customer_type] }}</span>
            </div>
            <div class="info_item">
                <span class="info_tit">邮箱：</span><span class="info_text">{{userdetail.email}}</span>
            </div>

            <div class="info_item">
                <span class="info_tit">地区：</span><span class="info_text"
                    v-if="userdetail.wechatUsers">{{userdetail.wechatUsers.country}} {{userdetail.wechatUsers.province}}
                    {{userdetail.wechatUsers.city}}</span>
            </div>
        </div>
        <div v-else>
            <div class="topuser">
                <div class="pic">
                    <img :src="userdetail.team_avatar" alt="">
                </div>
                <div class="username">
                    {{userdetail.team_name}}
                </div>
            </div>
            <div class="team_jj">
                <div class="jj"><span class="jj_tit">擅长：</span>{{userdetail.good_at}}</div>
                <div class="jj"><span class="jj_tit">简介：</span>{{userdetail.introduction}}</div>
            </div>
            <div>
                <div>
                    团队成员
                </div>
                <div class="team_user">
                    <div class="t_item" v-for="(ta,index) in userdetail.TeamTeamMember" :key="index">
                        <el-tooltip class="item" effect="dark" :content="'电话 '+ta.phone" placement="top-start">
                            <div class="t_u_a">
                                <img :src="ta.head_portrait_pic[0].url" alt="">
                            </div>
                        </el-tooltip>

                        <div class="t_u_n">
                            <div><span class="t_u_n_text_name">{{ta.real_name}} </span> <span class="t_u_n_text">
                                    {{ta.competent_id}}</span></div>
                            <div class="t_u_n_text">{{ta.hospital_id}} {{ta.department_id}}</div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="team_hz">
                <div>
                    团队患者
                </div>
                <div class="team_user">
                    <div class="t_item" v-if="userdetail.user">
                        <div class="t_u_a">
                            <img :src="userdetail.user.avatar" alt="">
                        </div>
                        <div class="t_u_n">
                            <div><span class="t_u_n_text_name">{{userdetail.user.nickname}} </span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        name: "chatList",
        props: ['to_user'],
        watch: {
            'to_user'(nVal, oVal) {}
        },
        data() {
            return {
                userdetail: '',
                loading: false,
                page: 0,
                curId: '',
                a: 1,
                // 总条数
                total: '',
                noMore: true,

            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
        },
        mounted() {

        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                if (!this.to_user.show_user_id) {
                    return false
                }
                this.loading = true
                axios.post('/admin/pc/KtUserChatlist/userInformation', {
                    user_type: this.to_user.show_user_type,
                    user_id: this.to_user.show_user_id,
                }, {
                    token: true
                }).then(res => {
                    this.userdetail = res.data.data
                    this.loading = false;
                }).catch((error) => {
                    console.log(error);
                    // this.loading = false;
                })
            },

            // 选择
            selectUser(item) {
                // let vue = this
                // vue.$parent.page = 1
                // this.curId = item.id
                // vue.$emit('setDataId', item)
            },
        },
        destroyed() {
            // this.bus.$off()
        }
    }
</script>

<style lang="scss" scoped>
    .chatList {
        // width: 100%;
        height: 742px;
        padding: 10px;
        border-right: 1px solid #ECECEC;

        .topuser {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .pic {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                overflow: hidden;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .username {
                margin-left: 10px;
                font-size: 17px;
                font-weight: 600;
                margin-right: 5px;
            }

            .sex {
                width: 20px;

                img {
                    width: 100%;
                }
            }
        }

        .team_jj {
            padding: 0px 0 10px;

            .jj {
                font-size: 14px;

                .jj_tit {
                    font-size: 14px;
                    color: #999;
                }
            }
        }

        .team_hz {
            margin-top: 30px;
        }


        .team_user {
            .t_item {
                display: flex;
                align-items: center;
                padding: 5px 10px;

                .t_u_a {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    overflow: hidden;

                    img {
                        width: 100%;
                        display: block;
                    }
                }

                .t_u_n {
                    margin-left: 10px;

                    .t_u_n_text_name {
                        font-size: 16px;
                    }

                    .t_u_n_text {
                        font-size: 12px;
                    }
                }
            }
        }

        .info_item {
            padding: 2px 0;

            .info_tit {
                font-size: 15px;
                color: #999;
            }

            +.info_text {
                font-size: 15px;
            }
        }

    }
</style>